export class InstallmentModel {
    constructor(
        public number: number,
        public interest: number,
        public minimum_value: number,
        public amount: number,
        public interest_amount: number,
        public percentage_interest: boolean,
        public discount_amount_installment: number,
        public percentage_discount: number,
        public id: number
    ) {}
}



// WEBPACK FOOTER //
// /codebuild/output/src2032928750/src/src/app/shared/models/installment.model.ts